<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 抽奖管理 / 中奖记录 / 编辑</span>
      </div>
      <div style="padding-top: 15px;">
        <table width="100%">
          <tr>
            <td class="leftTd">
              收货人姓名
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="name" class="boxText"/>

            </td>
          </tr>
          <tr>
            <td class="leftTd">
              收货人电话
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="phone" class="boxText"/>

            </td>
          </tr>
          <tr>
            <td class="leftTd">
              收货地址
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="address" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              物流
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="exp" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              备注
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="note" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              状态
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select v-model="state" class="boxText">
                <option value="0">待发货</option>
                <option value="1">已发货</option>
                <option value="2">已送达</option>
                <option value="5">已到账</option>
              </select>
            </td>
          </tr>
        </table>
      </div>

      <div style="padding-top: 15px; padding-bottom: 25px; padding-left: 150px">
        <input @click="addAdmin" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="保存" />
        <input @click="goback" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #ffffff; border: 1px solid #dbdbdb; margin-left: 15px; color: #606266" value="返回" />
      </div>
    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost, axiosPostJson} from "@/main";

export default {
  name: "UpdateAwardOrder",
  data(){
    return{
      id:"",
      name:"",
      phone:"",
      address:"0",
      exp:"",
      note:"",
      state:"",
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    let json=JSON.parse(localStorage.getItem("UPDATEOBJ"))
    console.log(json)
    this.id=json.orderId.toString()
    this.name=json.orderUserName.toString()
    this.phone=json.orderUserPhone.toString()
    this.address=json.orderUserAddress.toString()
    this.exp=json.orderExpressage.toString()
    this.note=json.orderNote.toString()
    this.state=json.orderState.toString()
  },
  methods: {
    addAdmin(){
      let that=this
      loading("请求中")
      let param="id="+this.id+"&name="+this.name+"&phone="+this.phone+"&address="+this.address+"&exp="+this.exp+"&note="+this.note+"&state="+this.state
      axiosPost(DO_NET_URL+"choujiang/UpdateAwardOrder?"+param,"",function (res){
        closeLoading()
        if(res.code==200){
          toask("保存成功",6)
          setTimeout(function (){
            that.$emit("send",'awardOrderList')
          },600)
        }else{
          toask(res.data,6)
        }
      })
    },
    goback(){
      this.$emit("send",'awardOrderList')
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>